<template>
  <div>
    <div class="widget-list widget-list-rounded m-b-30" data-id="widget">
      <a href="#" @click="fn_set('commissionname')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-th bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">佣金的名称</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['commissionname']"
        >
          {{giftset['commissionname'].value}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('commissionexpireday')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-cogs bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">佣金延后生效天数</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['commissionexpireday']"
        >
          {{giftset['commissionexpireday'].value}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('userlevel1commissionratio')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">一级用户发展佣金(元/人)</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['userlevel1commissionratio']"
        >
          {{giftset['userlevel1commissionratio'].value}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('userlevel2commissionratio')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-indigo text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">二级用户发展佣金(元/人)</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['userlevel2commissionratio']"
        >
          {{giftset['userlevel2commissionratio'].value}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('salelevel1commissionratio')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">一级用户销售额佣金比例(%)</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['salelevel1commissionratio']"
        >
          {{giftset['salelevel1commissionratio'].value}}%
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('salelevel2commissionratio')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-indigo text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">二级用户销售额佣金比例(%)</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['salelevel2commissionratio']"
        >
          {{giftset['salelevel2commissionratio'].value}}%
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
    </div>
    <Drawer :closable="true" title="设置" width="50" v-model="v_show">
      <Form :labelWidth="150">
        <FormItem :label="editLabel">
          <InputNumber style="width:200px" v-if="!editNameFlag" v-model="editValue"></InputNumber>
          <Input style="width:200px" v-else v-model="editValue" />
        </FormItem>
        <FormItem label>
          <div class="row">
            <div class="col-md-3">
              <button type="button" class="btn btn-theme" @click="fn_save">保存</button>
            </div>
            <div class="col-md-3">
              <button type="button" class="btn btn-danger" @click="fn_clear">清除</button>
            </div>
          </div>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>
<script>
import { getEnumByCode, saveEnumData } from "@/api/config";

export default {
  data() {
    return {
      giftset: {},
      v_show: false,
      code: "",

      editLabel: "",
      editValue: 0,
      editNameFlag: false
    };
  },
  mounted() {
    getEnumByCode(
      "userlevel2commissionratio,userlevel1commissionratio,salelevel1commissionratio,salelevel2commissionratio,commissionname,commissionexpireday"
    )
      .then(res => {
        this.giftset = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_set(code) {
      this.code = code;
      this.v_show = true;

      this.editNameFlag = false;
      switch (code) {
        case "userlevel2commissionratio":
          this.editValue = parseFloat(this.giftset[code].value);
          this.editLabel = "二级用户发展佣金";
          break;
        case "userlevel1commissionratio":
          this.editValue = parseFloat(this.giftset[code].value);
          this.editLabel = "一级用户发展佣金";
          break;
        case "salelevel1commissionratio":
          this.editValue = parseFloat(this.giftset[code].value);
          this.editLabel = "一级用户销售佣金%";
          break;
        case "salelevel2commissionratio":
          this.editValue = parseFloat(this.giftset[code].value);
          this.editLabel = "二级用户销售佣金%";
          break;
        case "commissionexpireday":
          this.editValue = parseFloat(this.giftset[code].value);
          this.editLabel = "佣金延后生效天数";
          break;
        case "commissionname":
          this.editLabel = "佣金名称";
          this.editValue = this.giftset[code].value;
          this.editNameFlag = true;
          break;
      }
    },

    fn_save() {
      //   console.log(this.code, this.couponid, this.couponname);

      saveEnumData({
        code: this.code,
        value: this.editValue,
        remarks: this.giftset[this.code].remarks
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.v_show = false;
            this.giftset[this.code].value = this.editValue;
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error("错误" + error);
        });
    },
    fn_clear() {
      saveEnumData({
        code: this.code,
        value: 0,
        remarks: ""
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.v_show = false;
            this.giftset[this.code].remarks = "";
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>